import axios from 'axios';
import { env } from '@config/env';
import { useAuthStore } from '../stores/authStore';
import { installInterceptors } from './interceptors';
import { refreshAuthTokens } from './authRefresh';
import { navigateTo } from '@shared/lib/navigation';

/**
 * Tenant (regional) API client. Base URL is dynamic — the regional edge
 * is determined by Core `/resolve-domain` and stored in authStore. We rebind
 * the baseURL on every request via the request interceptor below so that
 * tenant switches take effect immediately without rebuilding the instance.
 */
export const tenantApi = axios.create({
  timeout: 20_000,
  headers: { 'Content-Type': 'application/json' },
});

tenantApi.interceptors.request.use((config) => {
  const regional = useAuthStore.getState().regionalApiUrl;
  config.baseURL = regional || env.apiBaseUrl;
  return config;
});

installInterceptors(tenantApi, {
  refresh: refreshAuthTokens,
  // Signed out before the redirect: while the dead token is still held, /login bounces back into the app.
  onRefreshFailed: async () => {
    await useAuthStore.getState().signOut();
    navigateTo('/login', { replace: true });
  },
});
